module.exports = __webpack_public_path__ + "static/img/why-2-2.5e6acfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/why-2-2.png
// module id = B15d
// module chunks = 1